<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-notes`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M39 3a2 2 0 012 2l-.001 11.999h-4L37 7H9v36h10v4H7a2 2 0 01-2-2V5a2 2 0 012-2h32zm2.515 17.698l4.242 4.243c.781.781.538 2.29-.543 3.372L28.897 44.458c-.522.521-1.172.871-1.807.971l-5.039.796c-1.31.207-2.2-.683-1.993-1.993l.796-5.039c.1-.634.45-1.285.972-1.806l16.317-16.145c1.081-1.081 2.59-1.325 3.372-.544zm-1.312 4.355L24.29 40.58l-.396 1.811 1.81-.397 15.913-15.526-1.414-1.414zM24 21a1 1 0 011 1v2a1 1 0 01-1 1H14a1 1 0 01-1-1v-2a1 1 0 011-1h10zm8-8a1 1 0 011 1v2a1 1 0 01-1 1H14a1 1 0 01-1-1v-2a1 1 0 011-1h18z"/></svg>
</template>
<script>

export default {
  name: 'IconNotes',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
